import React from 'react';

const StockAdjustments = ({ data }) => {
    if (!data || !data.summary) return null;

    const s = data.summary;

    return (
        <div className="card shadow-sm h-100">
            <div className="card-body">
                <h6 className="card-title mb-3">Stock Adjustments</h6>
                <div className="row text-center g-2 mb-3">
                    <div className="col-4">
                        <div className="p-2 bg-light rounded">
                            <small className="text-muted d-block">Total Adjustments</small>
                            <strong>{s.total_count}</strong>
                        </div>
                    </div>
                    <div className="col-4">
                        <div className="p-2 bg-light rounded">
                            <small className="text-muted d-block">Total Qty</small>
                            <strong>{s.total_quantity?.toLocaleString(undefined, { minimumFractionDigits: 3 })}</strong>
                        </div>
                    </div>
                    <div className="col-4">
                        <div className="p-2 bg-light rounded">
                            <small className="text-muted d-block">Total Value</small>
                            <strong>{s.total_value?.toLocaleString(undefined, { minimumFractionDigits: 3 })}</strong>
                        </div>
                    </div>
                </div>
                {data.by_reason && data.by_reason.length > 0 && (
                    <div className="mb-3">
                        <h6 className="mb-2" style={{ fontSize: '0.85rem' }}>By Reason</h6>
                        <div className="table-responsive">
                            <table className="table table-sm table-bordered mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th>Reason</th>
                                        <th className="text-end">Count</th>
                                        <th className="text-end">Qty</th>
                                        <th className="text-end">Value</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.by_reason.map((r, i) => (
                                        <tr key={i}>
                                            <td>{r.reason}</td>
                                            <td className="text-end">{r.count}</td>
                                            <td className="text-end">{r.quantity?.toLocaleString(undefined, { minimumFractionDigits: 3 })}</td>
                                            <td className="text-end">{r.value?.toLocaleString(undefined, { minimumFractionDigits: 3 })}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default StockAdjustments;
